/**
 * Created by jacky on 3/12/16.
 * @flow
 * @providesModule Transition
 */

import React from "react";
import type {TransitionInfoType} from "../../lib/stories-shared";
import "./transition.scss";


type TransitionPropsType = {
    data: TransitionInfoType;
    pathProcessor: any;
}

export default function Transition (props: TransitionPropsType) {
    return (
        <path className="clsTransition" markerEnd="url(#clsArrow)" d={props.pathProcessor.path(props.data).toString()} />
    );
};



// WEBPACK FOOTER //
// ./src/components/Transition/transition.jsx